import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import SmallLoader from "@shared/components/Atoms/Loading/SmallLoading";
import { APP_NAME, LOGO } from "@shared/util/brand";
import { BRAND } from "@shared/brand";

const isCondense = BRAND.id === "condense";
const isNewzAgent = BRAND.id === "newzagent";
import NewzAgentLogo from "@shared/components/Atoms/NewzAgentLogo";
import CondenseLogo from "@shared/components/Atoms/CondenseLogo";
import WebinarVaultLogo from "@shared/components/Atoms/WebinarVaultLogo";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [step, setStep] = useState(1);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordValid, setPasswordValid] = useState(true);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({ ...prev, [id]: value }));

    if (id === "password") {
      setPasswordValid(value.length >= 3);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);

      if (isCondense || isNewzAgent) {
        if (!form.email || !form.firstName || !form.lastName) {
          setError("Please fill in all fields.");
          return;
        }
        await axios.post(
          `${import.meta.env.VITE_API_URL}/basic/demo-request`,
          {
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            source: window.location.href,
          }
        );
      } else {
        if (!form.email || !form.firstName || !form.lastName || !form.password) {
          setError("Please fill in all fields.");
          return;
        }
        await axios.post(
          `${import.meta.env.VITE_API_URL}/auth/register`,
          {
            firstname: form.firstName,
            lastname: form.lastName,
            email: form.email,
            password: form.password,
          }
        );
      }
      setStep(2);
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.msg || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.getElementById("firstName")?.focus();
  }, []);

  if (isCondense) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
          .cd-register { min-height: 100vh; background: #0d1f17; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
          .cd-register-glow { position: absolute; top: -15%; left: 50%; transform: translateX(-50%); width: 900px; height: 500px; background: radial-gradient(ellipse, rgba(22, 101, 52, 0.35) 0%, transparent 70%); filter: blur(100px); pointer-events: none; }
          .cd-register-card { position: relative; z-index: 1; width: 100%; max-width: 460px; margin: 0 16px; padding: 40px 32px 36px; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.10); border-radius: 20px; box-shadow: 0 20px 60px -20px rgba(0,0,0,.5); }
          .cd-register-logo { display: flex; justify-content: center; margin-bottom: 28px; }
          .cd-register-card label { display: block; margin-bottom: 6px; font-size: 14px; font-weight: 500; color: #cbd5e1; }
          .cd-register-card input { width: 100%; padding: 14px 16px; background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.10); border-radius: 12px; color: #f8fafc; font-size: 15px; font-family: inherit; outline: none; transition: border-color 0.2s; box-sizing: border-box; }
          .cd-register-card input::placeholder { color: #64748b; }
          .cd-register-card input:focus { border-color: rgba(34, 197, 94, 0.6); }
          .cd-register-field { margin-bottom: 16px; }
          .cd-register-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
          .cd-register-error { background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3); color: #fca5a5; padding: 10px 14px; border-radius: 10px; font-size: 14px; text-align: center; margin-bottom: 14px; }
          .cd-register-btn { width: 100%; padding: 14px; background: #15803d; color: #fff; font-size: 16px; font-weight: 700; border: none; border-radius: 12px; cursor: pointer; transition: background 0.2s, transform 0.2s, box-shadow 0.2s; box-shadow: 0 4px 15px rgba(21, 128, 61, 0.35); }
          .cd-register-btn:hover { background: #16a34a; transform: translateY(-1px); box-shadow: 0 8px 25px rgba(21, 128, 61, 0.45); }
          .cd-register-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }
          .cd-register-banner { background: linear-gradient(135deg, rgba(22, 101, 52, 0.3), rgba(22, 101, 52, 0.1)); border: 1px solid rgba(34, 197, 94, 0.25); border-radius: 12px; padding: 14px; text-align: center; font-weight: 600; font-size: 15px; color: #86efac; margin-bottom: 24px; }
          .cd-register-fine { text-align: center; font-size: 12px; color: #64748b; margin-top: 16px; line-height: 1.5; }
          .cd-register-fine a { color: #94a3b8; text-decoration: none; }
          .cd-register-fine a:hover { color: #f8fafc; }
          .cd-register-login { display: block; text-align: center; margin-top: 18px; color: #94a3b8; font-size: 14px; text-decoration: none; transition: color 0.2s; }
          .cd-register-login:hover { color: #f8fafc; }
          .cd-register-success { text-align: center; color: #f8fafc; }
          .cd-register-success h1 { font-size: 22px; font-weight: 700; margin-bottom: 12px; }
          .cd-register-success p { color: #94a3b8; font-size: 15px; line-height: 1.5; margin-bottom: 10px; }
          .cd-register-success .email-highlight { color: #86efac; font-weight: 600; }
          .cd-register-success .tips { text-align: left; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 16px; margin-top: 16px; font-size: 14px; color: #94a3b8; }
          .cd-register-success .tips strong { color: #cbd5e1; }
          .cd-register-success .tips ul { margin: 8px 0 0 20px; padding: 0; }
          .cd-register-success .tips li { margin-bottom: 4px; }
        `}</style>
        <div className="cd-register">
          <div className="cd-register-glow" />
          <div className="cd-register-card">
            <div className="cd-register-logo">
              <Link to="/"><CondenseLogo height={40} color="#ffffff" accentColor="#22c55e" /></Link>
            </div>
            {step === 1 && (
              <>
                <div className="cd-register-banner">Request a Free Trial</div>
                <form onSubmit={handleSubmit}>
                  <div className="cd-register-row">
                    <div className="cd-register-field">
                      <label htmlFor="firstName">First Name</label>
                      <input id="firstName" type="text" required value={form.firstName} onChange={handleChange} />
                    </div>
                    <div className="cd-register-field">
                      <label htmlFor="lastName">Last Name</label>
                      <input id="lastName" type="text" required value={form.lastName} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="cd-register-field">
                    <label htmlFor="email">Work Email</label>
                    <input id="email" type="email" required placeholder="you@company.com" value={form.email} onChange={handleChange} />
                  </div>
                  {error && <div className="cd-register-error">{error}</div>}
                  {loading && <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}><SmallLoader /></div>}
                  <button type="submit" disabled={loading} className="cd-register-btn">{loading ? "Submitting..." : "Request Free Trial"}</button>
                  <div className="cd-register-fine">By submitting, you agree to our <a href="/terms-of-service" target="_blank">Terms of Service</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>.</div>
                  {/* /login lives in the separate app bundle — needs a full page load */}
                  <a href="/login" className="cd-register-login">Already have an account? Sign in</a>
                </form>
              </>
            )}
            {step === 2 && (
              <div className="cd-register-success">
                <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                <h1>Thanks! We'll Be in Touch</h1>
                <p>Your free trial request has been received.<br />We'll reach out to <span className="email-highlight">{form.email}</span> shortly to get you set up.</p>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  if (isNewzAgent) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Montserrat:wght@700;900&display=swap');
          .nz-register {
            min-height: 100vh;
            background: #020617;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          }
          .nz-register-glow {
            position: absolute;
            top: -15%;
            left: 50%;
            transform: translateX(-50%);
            width: 900px;
            height: 500px;
            background: radial-gradient(ellipse, rgba(127,29,29,0.35) 0%, transparent 70%);
            filter: blur(100px);
            pointer-events: none;
          }
          .nz-register-card {
            position: relative;
            z-index: 1;
            width: 100%;
            max-width: 460px;
            margin: 0 16px;
            padding: 40px 32px 36px;
            background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.10);
            border-radius: 20px;
            box-shadow: 0 20px 60px -20px rgba(0,0,0,.6);
          }
          .nz-register-logo {
            display: flex;
            justify-content: center;
            margin-bottom: 28px;
          }
          .nz-register-card label {
            display: block;
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: 500;
            color: #cbd5e1;
          }
          .nz-register-card input {
            width: 100%;
            padding: 14px 16px;
            background: rgba(255,255,255,0.06);
            border: 1px solid rgba(255,255,255,0.10);
            border-radius: 12px;
            color: #f8fafc;
            font-size: 15px;
            font-family: inherit;
            outline: none;
            transition: border-color 0.2s;
            box-sizing: border-box;
          }
          .nz-register-card input::placeholder {
            color: #64748b;
          }
          .nz-register-card input:focus {
            border-color: rgba(220,38,38,0.6);
          }
          .nz-register-field {
            margin-bottom: 16px;
          }
          .nz-register-row {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 14px;
          }
          .nz-register-error {
            background: rgba(220,38,38,0.15);
            border: 1px solid rgba(220,38,38,0.3);
            color: #fca5a5;
            padding: 10px 14px;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            margin-bottom: 14px;
          }
          .nz-register-btn {
            width: 100%;
            padding: 14px;
            background: #dc2626;
            color: #fff;
            font-family: 'Montserrat', sans-serif;
            font-size: 16px;
            font-weight: 700;
            border: none;
            border-radius: 12px;
            cursor: pointer;
            transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
            box-shadow: 0 4px 15px rgba(220,38,38,0.3);
          }
          .nz-register-btn:hover {
            background: #ef4444;
            transform: translateY(-1px);
            box-shadow: 0 8px 25px rgba(220,38,38,0.4);
          }
          .nz-register-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
            transform: none;
          }
          .nz-register-banner {
            background: linear-gradient(135deg, rgba(220,38,38,0.2), rgba(220,38,38,0.08));
            border: 1px solid rgba(220,38,38,0.25);
            border-radius: 12px;
            padding: 14px;
            text-align: center;
            font-weight: 600;
            font-size: 15px;
            color: #fca5a5;
            margin-bottom: 24px;
          }
          .nz-register-fine {
            text-align: center;
            font-size: 12px;
            color: #64748b;
            margin-top: 16px;
            line-height: 1.5;
          }
          .nz-register-fine a {
            color: #94a3b8;
            text-decoration: none;
          }
          .nz-register-fine a:hover {
            color: #f8fafc;
          }
          .nz-register-login {
            display: block;
            text-align: center;
            margin-top: 18px;
            color: #94a3b8;
            font-size: 14px;
            text-decoration: none;
            transition: color 0.2s;
          }
          .nz-register-login:hover {
            color: #f8fafc;
          }
          .nz-register-success {
            text-align: center;
            color: #f8fafc;
          }
          .nz-register-success h1 {
            font-family: 'Montserrat', sans-serif;
            font-size: 22px;
            font-weight: 700;
            margin-bottom: 12px;
          }
          .nz-register-success p {
            color: #94a3b8;
            font-size: 15px;
            line-height: 1.5;
            margin-bottom: 10px;
          }
          .nz-register-success .email-highlight {
            color: #fca5a5;
            font-weight: 600;
          }
          .nz-register-success .tips {
            text-align: left;
            background: rgba(255,255,255,0.04);
            border: 1px solid rgba(255,255,255,0.08);
            border-radius: 12px;
            padding: 16px;
            margin-top: 16px;
            font-size: 14px;
            color: #94a3b8;
          }
          .nz-register-success .tips strong {
            color: #cbd5e1;
          }
          .nz-register-success .tips ul {
            margin: 8px 0 0 20px;
            padding: 0;
          }
          .nz-register-success .tips li {
            margin-bottom: 4px;
          }
        `}</style>
        <div className="nz-register">
          <div className="nz-register-glow" />
          <div className="nz-register-card">
            <div className="nz-register-logo">
              <Link to="/">
                <NewzAgentLogo height={40} color="#ffffff" accentColor="#ef4444" />
              </Link>
            </div>

            {step === 1 && (
              <>
                <div className="nz-register-banner">
                  Request a Free Trial
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="nz-register-row">
                    <div className="nz-register-field">
                      <label htmlFor="firstName">First Name</label>
                      <input
                        id="firstName"
                        type="text"
                        required
                        value={form.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="nz-register-field">
                      <label htmlFor="lastName">Last Name</label>
                      <input
                        id="lastName"
                        type="text"
                        required
                        value={form.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="nz-register-field">
                    <label htmlFor="email">Work Email</label>
                    <input
                      id="email"
                      type="email"
                      required
                      placeholder="you@company.com"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>

                  {error && <div className="nz-register-error">{error}</div>}
                  {loading && <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}><SmallLoader /></div>}

                  <button type="submit" disabled={loading} className="nz-register-btn">
                    {loading ? "Submitting..." : "Request Free Trial"}
                  </button>

                  <div className="nz-register-fine">
                    By submitting, you agree to our{" "}
                    <a href="/terms-of-service" target="_blank">Terms of Service</a>{" "}
                    and{" "}
                    <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
                  </div>

                  <a href="/login" className="nz-register-login">
                    Already have an account? Sign in
                  </a>
                </form>
              </>
            )}

            {step === 2 && (
              <div className="nz-register-success">
                <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                <h1>Thanks! We'll Be in Touch</h1>
                <p>
                  Your free trial request has been received.<br />
                  We'll reach out to <span className="email-highlight">{form.email}</span> shortly to get you set up.
                </p>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#4a90e2] to-[#357abd] p-5 relative font-sans">
      {/* Floating Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute w-20 h-20 bg-white/10 rounded-full top-[10%] left-[10%] animate-float delay-0" />
        <div className="absolute w-32 h-32 bg-white/10 rounded-full top-[60%] right-[10%] animate-float delay-2000" />
        <div className="absolute w-16 h-16 bg-white/10 rounded-full bottom-[20%] left-[20%] animate-float delay-4000" />
      </div>

      <div className="absolute top-5 left-5 z-10">
        <Link to="/">
          <WebinarVaultLogo height={36} color="#ffffff" accentColor="#ffffff" />
        </Link>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-1 gap-10 items-center min-h-[calc(100vh-40px)] relative z-10">
        {/* Form Card */}
        <div className="bg-white rounded-2xl p-10 shadow-xl max-w-md mx-auto w-full">
          {step === 1 && (
            <div className="max-w-md mx-auto w-full">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-semibold text-[#2c5aa0] mb-2">
                  Start Your Free Trial
                </h2>
                <p className="text-gray-600 text-sm">
                  Great! So glad you're considering a 3-day free trial.
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-500 to-green-600 text-white text-center font-medium py-4 rounded-xl mb-6">
                🚀 3 Days Free • No Credit Card Required
              </div>

              <form onSubmit={handleSubmit}>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium text-gray-800 mb-1"
                    >
                      First Name
                    </label>
                    <input
                      id="firstName"
                      type="text"
                      required
                      value={form.firstName}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium text-gray-800 mb-1"
                    >
                      Last Name
                    </label>
                    <input
                      id="lastName"
                      type="text"
                      required
                      value={form.lastName}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-800 mb-1"
                  >
                    Work Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    required
                    placeholder="you@company.com"
                    value={form.email}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>

                <div className="mt-4">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-800 mb-1"
                  >
                    Create Password
                  </label>
                  <input
                    id="password"
                    type="password"
                    required
                    placeholder="At least 8 characters"
                    value={form.password}
                    onChange={handleChange}
                    className={`form-input ${
                      form.password && !passwordValid
                        ? "border-red-500"
                        : form.password && passwordValid
                        ? "border-green-500"
                        : ""
                    }`}
                  />
                </div>

                <div className="text-xs text-gray-500 flex justify-center items-center gap-1 mt-4">
                  🔒 Your information is secure and encrypted
                </div>
                {error && (
                  <div className="bg-red-100 text-red-700 px-4 py-2 rounded text-sm text-center mb-2">
                    {error}
                  </div>
                )}
                {loading && <SmallLoader />}
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-4 mt-6 text-white font-semibold text-lg rounded-xl bg-gradient-to-br from-[#4a90e2] to-[#357abd] hover:shadow-lg transition-all duration-300 disabled:opacity-60"
                >
                  {loading
                    ? "Creating your account..."
                    : "Start My Free 3-Day Trial →"}
                </button>

                <p className="text-center text-xs text-gray-500 mt-4 leading-5">
                  By signing up, you agree to our{" "}
                  <a
                    href="/terms-of-service"
                    target="_blank"
                    className="text-[#4a90e2] hover:underline"
                  >
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a
                    href="privacy-policy"
                    target="_blank"
                    className="text-[#4a90e2] hover:underline"
                  >
                    Privacy Policy
                  </a>
                  . You will have to convert to our Executive or Pro plan after
                  the trial.
                </p>
              </form>
            </div>
          )}

          {step === 2 && (
            <div>
              <div className="w-20 h-20 mx-auto rounded-full bg-green-600 text-white flex items-center justify-center text-3xl mb-6">
                ✉️
              </div>
              <h1 className="text-2xl font-semibold text-[#2E5A87] mb-2">
                Check Your Email
              </h1>
              <p className="text-gray-600 mb-4">
                Email verify link sent successfully
              </p>
              <p className="text-gray-600 mb-4">
                We've sent a verify link to: <br />
                <span className="text-[#2E5A87] font-semibold">
                  {form.email}
                </span>
              </p>
              <p className="text-gray-600 mb-6">
                Click the link in your email to reset your password. If you
                don't see it, check your spam folder.
              </p>
              <div className="text-sm text-gray-600 bg-gray-100 p-4 text-left rounded-lg mb-6">
                <strong>Can't find the email?</strong>
                <ul className="list-disc ml-6 mt-2">
                  <li>Check your spam or junk mail folder</li>
                  <li>Make sure you entered the correct email address</li>
                  <li>Wait a few minutes - emails can sometimes be delayed</li>
                  <li>Add the sender to your email contacts</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
